module.exports = __webpack_public_path__ + "static/media/who-is-a-historian.333a2ace.png";